export default "__VITE_ASSET__CXJ5z6BZ__"